import React from 'react';

interface QualityMetricProps {
  value: number | string;
  label: string;
  color?: 'green' | 'blue' | 'purple';
}

export const QualityMetric: React.FC<QualityMetricProps> = ({
  value,
  label,
  color = 'green',
}) => {
  const colorClasses = {
    green: 'text-green-600',
    blue: 'text-blue-600',
    purple: 'text-purple-600',
  };

  return (
    <div className="text-center p-4 border rounded-lg">
      <p className={`text-2xl font-bold ${colorClasses[color]}`}>{value}</p>
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
};
